import * as t from 'io-ts'

import fetchApi from "ui-io/fetch-api";

export const taskRemoveAttachmentMutation = ({
  taskId,
  attachmentId,
}: {
  taskId: string
  attachmentId: string
}) =>
  fetchApi({
    service: 'admin-service',
    method: 'POST',
    pathname: `/tasks/${taskId}/attachments/${attachmentId}`,
    codec:t.type({
			acknowledged: t.boolean,
			modifiedCount: t.number,
			upsertedId: t.union([t.string,t.null]),
			upsertedCount: t.number,
			matchedCount: t.number
		}),
  })
